import { AuthPage, ResetPasswordPage } from '@pages/auth'
import { RegisterPage } from '@pages/register'
import { ChoosePackage } from '@components/registration'
import { BroadcastMessagePage } from '@pages/broadcast-message-page'
import { CalibrationPage, PostCalibrationPage, PreCalibrationPage } from '@pages/calibration'
import { CalibrationRulesPage } from '@pages/calibration-rules-page'
import { MappingsPage } from '@pages/mappings-page'
// import { PlansAdminPage } from '@pages/plans-admin-page' // hidden for now, see the commented routes below
// import { BillingAccountsPage } from '@pages/billing-accounts-page'
import { CalibrationCenterListPage, NewCalibrationCenterPage } from '@pages/calibration-center'
import { ClientInvoiceDocumentPage, ClientInvoicePhotoPage, ClientInvoiceSummaryPage } from '@pages/client-invoice'
import { ClientListPage } from '@pages/client-list-page'
import { DocumentPage } from '@pages/document-page'
import { HomePage } from '@pages/home-page'
import { InvoiceQueuePage, InvoiceSummaryPage } from '@pages/invoice'
import { ClientDetailsPage } from '@pages/client-details-page'
import { PhotoPage } from '@pages/photo-page'
import { ProductsPage } from '@pages/products-page'
import { QwiSearchPage } from '@pages/qwi-search-page'
import { NewQuote, QuoteDocument, QuotePage, QuoteSummaryPage } from '@pages/quotes'
import { SettingsPage } from '@pages/settings-page'
import { SupportPage } from '@pages/support-page'
import { AppTrainingPage } from '@pages/app-training-page'
import { SupportQueuePage, SupportRequestPage, CreateSupportRequestPage } from '@pages/support'
import { GlobalClientsPage } from '@pages/global-clients-page'
import { NetworkPage } from '@pages/network'
import { ManageUsersListPage } from '@pages/user/manage-user-list-page'
import { VehicleInfoPage } from '@pages/vehicle-info-page'
import { VinSearchPage } from '@pages/vin-search-page'
import { NewWorkOrderPage, WorkOrderPage, WorkOrderSummaryPage } from '@pages/work-order'
import { AuthRoute } from '@routes/app-route/auth-route'
import { PrivateRoute } from '@routes/app-route/private-route'
import { Redirect, Route, Switch } from 'react-router-dom'
import { HealthCheckPage } from '@pages/health-check'
import { REDIRECT_URLS } from '../../constants'
import { ForbiddenRoute } from './forbidden-route'
import { CalendarPage } from '@pages/calendar-page'
import { SchedulerPage } from '@pages/scheduler'
import {
  QueuePage as AdasIntelligenceQueuePage,
  EstimateDetailPage as AdasIntelligenceDetailPage,
  ReportsPage as AdasIntelligenceReportsPage
} from '@pages/adas-intelligence'

export const AppRoutes = () => {
  return (
    <>
      <Switch>
        <ForbiddenRoute path={REDIRECT_URLS.FORBIDDEN_PAGE} exact />
        <AuthRoute path='/authenticate' exact component={AuthPage} />
        <PrivateRoute path='/' exact component={HomePage} usePageLayout={true} layoutProps={{ title: 'Home' }} />
        {/* Clients and Products read center-wide data the backend refuses a client user
            (ClientScopeFilter), so the routes are closed to them too. VIN Search and the
            Scheduler stay open: the backend narrows their results to the user's own client. */}
        <PrivateRoute path='/vinsearch' exact component={VinSearchPage} usePageLayout={true} layoutProps={{ title: 'VIN Search' }} />
        <PrivateRoute
          path='/clients'
          exact
          component={ClientListPage}
          usePageLayout={true}
          layoutProps={{ title: 'Clients' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute
          path={REDIRECT_URLS.CLIENT_DETAILS}
          exact
          component={ClientDetailsPage}
          usePageLayout={true}
          layoutProps={{ title: 'Client' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute
          path='/products'
          exact
          component={ProductsPage}
          usePageLayout={true}
          layoutProps={{ title: 'Products' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute
          path={REDIRECT_URLS.NEW_QUOTE}
          exact
          component={NewQuote}
          componentProps={{ isNewWorkOrder: true }}
          usePageLayout={true}
          layoutProps={{ title: 'New Quote' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute path='/quotes' exact component={QuotePage} usePageLayout={true} layoutProps={{ title: 'Quotes' }} />
        <PrivateRoute
          path={REDIRECT_URLS.QUOTE_SUMMARY}
          exact
          component={QuoteSummaryPage}
          usePageLayout={true}
          layoutProps={{ title: 'Quote Summary' }}
        />
        <PrivateRoute
          path={REDIRECT_URLS.QUOTE_DOCUMENT}
          exact
          component={QuoteDocument}
          usePageLayout={true}
          layoutProps={{ title: 'Documents' }}
        />
        <PrivateRoute
          path={REDIRECT_URLS.QUOTE_VEHICLE_INFO}
          exact
          component={VehicleInfoPage}
          componentProps={{ fromQuote: true, isNewWorkOrder: false, title: 'Vehicle Info' }}
          usePageLayout={true}
        />
        <PrivateRoute path='/workorders' exact component={WorkOrderPage} usePageLayout={true} layoutProps={{ title: 'Work Orders' }} />
        <PrivateRoute
          path={REDIRECT_URLS.NEW_WORK_ORDER}
          exact
          component={NewWorkOrderPage}
          usePageLayout={true}
          layoutProps={{ title: 'New Work Order' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute
          path={REDIRECT_URLS.WORK_ORDER_SUMMARY}
          exact
          component={WorkOrderSummaryPage}
          usePageLayout={true}
          layoutProps={{ title: 'WO Summary' }}
        />
        <PrivateRoute
          path={REDIRECT_URLS.WORK_ORDER_DOCUMENT}
          exact
          component={DocumentPage}
          usePageLayout={true}
          layoutProps={{ title: 'Documents' }}
        />
        <PrivateRoute
          path={REDIRECT_URLS.WORK_ORDER_CALIBRATION}
          exact
          component={CalibrationPage}
          usePageLayout={true}
          layoutProps={{ title: 'Calibration' }}
        />
        <PrivateRoute path={REDIRECT_URLS.WORK_ORDER_PRE_CALIBRATION} exact component={PreCalibrationPage} usePageLayout={true} />
        <PrivateRoute path={REDIRECT_URLS.WORK_ORDER_POST_CALIBRATION} exact component={PostCalibrationPage} usePageLayout={true} />
        <PrivateRoute path={REDIRECT_URLS.WORK_ORDER_PHOTO} exact component={PhotoPage} usePageLayout={true} />
        <PrivateRoute
          path={REDIRECT_URLS.WORK_ORDER_VEHICLE_INFO}
          exact
          component={VehicleInfoPage}
          componentProps={{ fromWorkOrder: true, isNewWorkOrder: false, title: 'Vehicle Info' }}
          usePageLayout={true}
        />
        <PrivateRoute path='/invoices' exact component={InvoiceQueuePage} usePageLayout={true} layoutProps={{ title: 'Invoices' }} />
        <PrivateRoute
          path={REDIRECT_URLS.INVOICE_SUMMARY}
          exact
          component={InvoiceSummaryPage}
          componentProps={{ fromInvoice: true }}
          usePageLayout={true}
          layoutProps={{ title: 'Invoice Summary' }}
        />
        <PrivateRoute
          path={REDIRECT_URLS.INVOICE_DOCUMENT}
          exact
          component={DocumentPage}
          componentProps={{ fromInvoice: true }}
          usePageLayout={true}
          layoutProps={{ title: 'Documents' }}
        />
        <PrivateRoute
          path={REDIRECT_URLS.INVOICE_CALIBRATION}
          exact
          componentProps={{ fromInvoice: true }}
          component={CalibrationPage}
          usePageLayout={true}
          layoutProps={{ title: 'Calibration' }}
        />
        <PrivateRoute
          path={REDIRECT_URLS.INVOICE_PRE_CALIBRATION}
          exact
          component={PreCalibrationPage}
          componentProps={{ fromInvoice: true }}
          usePageLayout={true}
          layoutProps={{ title: 'Pre Calibration' }}
        />
        <PrivateRoute
          path={REDIRECT_URLS.INVOICE_POST_CALIBRATION}
          exact
          component={PostCalibrationPage}
          componentProps={{ fromInvoice: true }}
          layoutProps={{ title: 'Post Calibration' }}
          usePageLayout={true}
        />
        <PrivateRoute
          path={REDIRECT_URLS.INVOICE_PHOTO}
          exact
          component={PhotoPage}
          componentProps={{ fromInvoice: true }}
          usePageLayout={true}
        />
        <PrivateRoute
          path={REDIRECT_URLS.INVOICE_VEHICLE_INFO}
          exact
          component={VehicleInfoPage}
          componentProps={{ fromInvoice: true, isNewWorkOrder: false, title: 'Vehicle Info' }}
          usePageLayout={true}
        />
        <PrivateRoute
          path='/manage-location'
          exact
          component={CalibrationCenterListPage}
          usePageLayout={true}
          layoutProps={{ title: 'Manage Locations' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute path='/qwi-search' exact component={QwiSearchPage} usePageLayout={true} layoutProps={{ title: 'QWI Search' }} />
        <PrivateRoute path={REDIRECT_URLS.NETWORK} exact component={NetworkPage} usePageLayout={true} layoutProps={{ title: 'Network' }} />
        <PrivateRoute
          path='/manage-users'
          exact
          component={ManageUsersListPage}
          usePageLayout={true}
          layoutProps={{ title: 'Global Directory' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute
          path={REDIRECT_URLS.GLOBAL_CLIENTS}
          exact
          component={GlobalClientsPage}
          usePageLayout={true}
          layoutProps={{ title: 'Global Clients' }}
        />
        <PrivateRoute
          path='/manage-location/new-location'
          exact
          component={NewCalibrationCenterPage}
          usePageLayout={true}
          layoutProps={{ title: 'New Location' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute path='/support' exact component={SupportQueuePage} usePageLayout={true} layoutProps={{ title: 'Support' }} />
        <PrivateRoute
          path='/support/support-request'
          exact
          component={SupportRequestPage}
          usePageLayout={true}
          layoutProps={{ title: 'Create Support Request' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute
          path='/support/support-request/:ticketRequestId'
          exact
          component={CreateSupportRequestPage}
          usePageLayout={true}
          layoutProps={{ title: 'View Support Request' }}
        />
        <PrivateRoute
          path='/support/create-support-request'
          exact
          component={CreateSupportRequestPage}
          usePageLayout={true}
          layoutProps={{ title: 'Create Support Request' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute
          path='/broadcast-message'
          exact
          component={BroadcastMessagePage}
          usePageLayout={true}
          layoutProps={{ title: 'Broadcast Messages' }}
          blockReadOnlyAccess={true}
        />
        {/* Rule-library maintenance over platform-global data — system admins only
            (never center admins/managers), hence adminOnly on top of the hidden nav. */}
        <PrivateRoute
          path='/calibration-rules'
          exact
          component={CalibrationRulesPage}
          adminOnly={true}
          usePageLayout={true}
          layoutProps={{ title: 'Calibration Rules' }}
        />
        <PrivateRoute
          path='/mappings'
          exact
          component={MappingsPage}
          adminOnly={true}
          usePageLayout={true}
          layoutProps={{ title: 'Mappings' }}
        />
        {/* Hidden for now (user request 2026-10-27): Plans & Features and Billing Accounts. Uncomment this
            block, the two imports above and the sidebar entries in NavigationBar to re-enable.
        <PrivateRoute
          path='/admin/plans'
          exact
          component={PlansAdminPage}
          adminOnly={true}
          usePageLayout={true}
          layoutProps={{ title: 'Plans & Features' }}
        />
        <PrivateRoute
          path='/admin/billing-accounts'
          exact
          component={BillingAccountsPage}
          adminOnly={true}
          usePageLayout={true}
          layoutProps={{ title: 'Billing Accounts' }}
        />
        */}
        <PrivateRoute
          path='/settings'
          exact
          component={SettingsPage}
          usePageLayout={true}
          layoutProps={{ title: 'Settings', fullWidth: true }}
          blockTechAccess={true}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute
          path='/help'
          exact
          component={SupportPage}
          usePageLayout={true}
          layoutProps={{ title: 'Support Page' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute path='/app-training' exact component={AppTrainingPage} usePageLayout={true} layoutProps={{ title: 'Library' }} />
        <PrivateRoute path='/health-check' exact component={HealthCheckPage} usePageLayout={true} layoutProps={{ title: '' }} />
        <PrivateRoute
          path='/calendar'
          exact
          component={CalendarPage}
          usePageLayout={true}
          layoutProps={{ title: 'Calendar Settings' }}
          blockReadOnlyAccess={true}
        />
        <PrivateRoute
          path='/scheduler'
          exact
          component={SchedulerPage}
          usePageLayout={true}
          layoutProps={{ title: 'Appointment Schedule', fullWidth: true }}
        />
        <PrivateRoute
          path='/adas-intelligence'
          exact
          component={AdasIntelligenceQueuePage}
          usePageLayout={true}
          layoutProps={{ title: 'ADAS Intelligence' }}
        />
        <PrivateRoute
          path='/adas-intelligence/reports'
          exact
          component={AdasIntelligenceReportsPage}
          usePageLayout={true}
          layoutProps={{ title: 'ADAS Intelligence' }}
        />
        <PrivateRoute
          path='/adas-intelligence/estimate/:id'
          exact
          component={AdasIntelligenceDetailPage}
          usePageLayout={true}
          layoutProps={{ title: 'ADAS Intelligence' }}
        />
        <Route path='/reset' component={ResetPasswordPage} />
        <Route path='/register' component={RegisterPage} />
        {/* Signed in, no package yet: where a new owner lands after confirming their email. */}
        <PrivateRoute path='/packages' exact component={ChoosePackage} usePageLayout={false} />
        <Route path={REDIRECT_URLS.CLIENT_INVOICE_SUMMARY_PHOTO} exact component={ClientInvoicePhotoPage} />
        <Route path={REDIRECT_URLS.CLIENT_INVOICE_SUMMARY_DOCUMENT} exact component={ClientInvoiceDocumentPage} />
        <Route path={REDIRECT_URLS.CLIENT_INVOICE_SUMMARY} component={ClientInvoiceSummaryPage} />
        <Route path='*'>
          <Redirect to='/authenticate' />
        </Route>
      </Switch>
    </>
  )
}
